import { Link } from 'react-router-dom';
import { comics } from '@/mocks/comics';

export default function HotRanking() {
  const ranked = [...comics]
    .sort((a, b) => b.views - a.views)
    .slice(0, 10);

  return (
    <section className="px-4 md:px-6 py-10 md:py-14">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900">
            人气排行
          </h2>
          <p className="text-sm text-foreground-500 mt-1">全站最受欢迎的漫画</p>
        </div>
        <Link
          to="/category/all"
          className="text-sm text-primary-500 hover:text-primary-600 font-medium flex items-center gap-1 whitespace-nowrap transition-colors"
        >
          查看全部
          <i className="ri-arrow-right-line"></i>
        </Link>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        {ranked.map((comic, index) => (
          <Link
            key={comic.id}
            to={`/comic/${comic.id}`}
            className="flex items-center gap-4 p-3 rounded-lg bg-background-100 hover:bg-primary-50 transition-colors duration-200 group cursor-pointer"
          >
            <div className="flex items-center gap-2 min-w-[40px]">
              <span
                className={`text-lg font-heading font-bold whitespace-nowrap ${
                  index < 3 ? 'text-primary-500' : 'text-foreground-400'
                }`}
              >
                {String(index + 1).padStart(2, '0')}
              </span>
            </div>
            <div className="w-12 h-16 flex-shrink-0 rounded overflow-hidden">
              <img
                src={comic.cover}
                alt={comic.title}
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="flex-1 min-w-0">
              <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors duration-200 truncate">
                {comic.title}
              </h3>
              <p className="text-xs text-foreground-500 mt-0.5 whitespace-nowrap">{comic.author}</p>
              <div className="flex items-center gap-3 mt-1">
                <span className="text-xs text-accent-600 flex items-center gap-0.5">
                  <i className="ri-star-fill text-[10px]"></i>
                  {comic.rating}
                </span>
                <span className="text-xs text-foreground-400">
                  {(comic.views / 10000).toFixed(1)}万人气
                </span>
              </div>
            </div>
            <span
              className={`text-[10px] px-2 py-0.5 rounded-full whitespace-nowrap ${
                comic.status === 'ongoing'
                  ? 'bg-accent-100 text-accent-700'
                  : 'bg-secondary-100 text-secondary-700'
              }`}
            >
              {comic.status === 'ongoing' ? '连载' : '完结'}
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}